'use client';
/* eslint-disable no-restricted-imports */
import Search from '~/client/components/Search';
import LegacyStyledComponentsPage from '~/client/containers/LegacyStyledComponentsPage';
import useSearchStore from '@/client/hooks/useSearchStore';

type Props = {
  searchParam?: string;
};

const SearchClient: FC<Props> = ({ searchParam }) => {
  const { search } = useSearchStore();
  return (
    <LegacyStyledComponentsPage>
      <Search searchParam={search || searchParam} />
    </LegacyStyledComponentsPage>
  );
};
export default SearchClient;
